import { z } from "zod";

import { oAuthConfigSchema } from "../event-notification/oauth-config-schema";
import { httpHeaderSchema } from "../shared/http-header-schema";

import { securePrintAuthenticationTypeSchema } from "./secure-print-authentication-type-schema";

export const externalIntegrationSchema = z.object({
	enabled: z.boolean(),
	url: z.string().nullable(),
	apiKey: z.string().nullable().optional(),
	basicAuthSecret: z.string().nullable().optional(),
	authenticationType: securePrintAuthenticationTypeSchema,
	oauth: oAuthConfigSchema.nullable().optional(),
	httpHeaders: z.array(httpHeaderSchema).optional(),
});

export type ExternalIntegration = z.infer<typeof externalIntegrationSchema>;
